export default __webpack_public_path__ + "static/media/CARA_logo.13134818.png";